import { Tabs } from "antd";
import styled from "styled-components";

import { Palette } from "../../../../core/styles/theme";
import { formTabStyle } from "./Styles";

const FormTabAntStyled = styled(Tabs)`
    &.ant-tabs {
        color: black;
        font-family: "AeviFont";
        font-size: 11pt;
    }

    &.ant-tabs .ant-tabs-tab:hover {
        color: black;
    }

    &.ant-tabs .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
        color: black;
        font-size: 11pt;
    }

    &.ant-tabs .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn:active {
        color: black;
    }

    &.ant-tabs .ant-tabs-ink-bar {
        background: ${Palette.HeroGreen};
    }

    &.ant-tabs-top > .ant-tabs-nav::before {
        border-bottom: none !important;
    }
`;

const FormTabStyled = styled.div`
    ${formTabStyle};
`;
export const FormTab = styled(FormTabAntStyled).attrs(() => ({ className: "aevi-form-tab" as string }))``;
export const FormTabHtml = styled(FormTabStyled).attrs(() => ({ className: "aevi-form-tab" as string }))``;
export const FormTabActiveHtml = styled(FormTabStyled).attrs(() => ({ className: "aevi-form-tab aevi-form-tab-active" as string }))``;
